module.exports = __webpack_public_path__ + "images/771551b909fd715c3a185f8e86225bb8.svg";